export default __webpack_public_path__ + "static/media/cover1.ebaec561.png";